import ApiClient from "./api";
const clients = {
  api: ApiClient,
};

export default clients;
